/** @format */

import React, { useState } from "react";
import { FormProps } from "antd/lib/form";
import { ILoginFormProps } from "./LoginForm.types";
import { InputProps } from "antd/lib/input";
import LoginFormView from "./LoginForm.view";

const LoginFormContainer: React.FC<ILoginFormProps> = (props) => {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();

  const checkEmailIsNotEmpty = (): boolean =>
    email !== undefined && email !== "";

  const checkPasswordIsNotEmpty = (): boolean =>
    password !== undefined && password !== "";

  const checkFormFieldsAreValid = (): boolean =>
    checkEmailIsNotEmpty() && checkPasswordIsNotEmpty();

  const calculateDisableLogIn = (): boolean => !checkFormFieldsAreValid();

  function onChangeEmail(value) {
    setEmail(value);
  }

  function onChangePassword(value) {
    setPassword(value);
  }

  async function onClickLogIn(): Promise<string> {
    if (
      email !== undefined &&
      password !== undefined &&
      password !== "" &&
      email !== ""
    ) {
      const clickResponse = await props.onClickLogIn({ email, password });
      return clickResponse;
    } else {
      return "Please enter your email and password";
    }
  }

  return (
    <LoginFormView
      disableLogIn={calculateDisableLogIn()}
      email={email}
      onChangeEmail={onChangeEmail}
      onChangePassword={onChangePassword}
      onClickLogIn={onClickLogIn}
      password={password}
    />
  );
};

export default LoginFormContainer;
